/* eslint-disable eqeqeq */
/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "antd";
import CustomInput from "../../../Core/Components/CustomInput";
import useSearch from "../../../Core/hooks/useSearch";
import { updateTrips } from "../../../Redux/Slices/trips.slice";
import Button from "../../../Core/Components/CustomButton";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import ToastMessageModal from "../ToastMessageModal";
import getBatteryStatus from "../../../Utils/getBatteryStatus";
import BatteryPercentageStatus from "../../Battery/phase3/BatteryPercentageStatus";
import { BatteryEmptyState } from "./EmptyState";
import { client } from "../../../Utils/axiosClient";
import { BatterySecondaryIcon } from "../../../Common/Svgs/BatteryIcon";
import ChargerIcon from "../../../Common/Svgs/ChargerIcon";

const TripStep5 = () => {
  const dispatch = useDispatch();

  const { tripDetails, toastMessage, stops, loading, calculatedRouteDistance } =
    useSelector((state) => state.trips);

  // const { allBatteries } = useSelector((state) => state.batteries);

  const [focus, setFocus] = useState(false);
  const [batteriesInSystem, setBatteriesInSystem] = useState([]);
  const [required, setRequired] = useState({
    batteries: 3,
    energy: 9,
    kawi160: 0,
    kawi370: 0,
  });

  const { filteredData, search, setSearch } = useSearch(batteriesInSystem, [
    "value",
    "lockerId",
    "assignedTo",
  ]);

  const handleSelection = (battery) => {
    const batteries = tripDetails?.batteries;

    const updatedBatteries = batteries.includes(battery.id)
      ? batteries.filter((id) => id !== battery.id)
      : [...batteries, battery.id];

    dispatch(
      updateTrips({
        key: "tripDetails",
        value: {
          ...tripDetails,
          batteries: updatedBatteries,
        },
      }),
    );
  };

  const onClearSelection = () => {
    dispatch(
      updateTrips({
        key: "tripDetails",
        value: { ...tripDetails, batteries: [] },
      }),
    );
  };

  // find the batteries currently in hub station (hub station == origin while creating the trip)
  // const getBatteries = useCallback(() => {
  //   let batteryStatusToCheck = [];

  //   // if creating a new trip and start date = current date, return only hub station batteries
  //   if (dayjs(tripDetails.startDate).isSame(dayjs(), "day")) {
  //     batteryStatusToCheck = [BATTERY_STATUS.HUB_STATION];
  //   }
  //   // if trip date = future date, return all the batteries
  //   else {
  //     batteryStatusToCheck = [
  //       BATTERY_STATUS.ON_A_TRIP,
  //       BATTERY_STATUS.DISPATCHED,
  //       BATTERY_STATUS.HUB_STATION,
  //       BATTERY_STATUS.IN_TRANSIT,
  //     ];
  //   }

  //   const hubStationBatteries = allBatteries
  //     .filter(
  //       (item) =>
  //         batteryStatusToCheck.includes(+item.status) &&
  //         item.currentHubId == stops[0].locationId,
  //     )
  //     .map((battery) => ({
  //       ...battery,
  //       id: battery.id,
  //       value: battery.registrationNo,
  //     }));

  //   setBatteriesInSystem(hubStationBatteries);
  // }, [allBatteries, stops, tripDetails]);

  const getBatteries = async () => {
    try {
      dispatch(updateTrips({ key: "loading", value: true }));

      const params = {
        stops: stops.map((item) => +item.locationId),
        startDate: tripDetails?.startDate,
        hubId: stops[0].locationId,
        distance: calculatedRouteDistance,
      };

      const response = await client.get(
        `${process.env.REACT_APP_API_URL}/trip/create-trip-batteries`,
        { params },
      );

      if (response.status === 200) {
        const {
          requiredBatteries,
          requiredEnergy,
          batteries,
          kawi160,
          kawi370,
        } = response.data;

        setBatteriesInSystem(batteries);

        setRequired({
          batteries: requiredBatteries,
          energy: requiredEnergy,
          kawi160,
          kawi370,
        });

        const validBatteryIds = (batteries || []).map((b) => b.id);
        const currentSelected = tripDetails?.batteries || [];
        const sanitizedSelected = currentSelected.filter((id) =>
          validBatteryIds.includes(id),
        );

        dispatch(
          updateTrips({
            key: "tripDetails",
            value: {
              ...tripDetails,
              batteries: sanitizedSelected,
              estimatedRequiredEnergy: requiredEnergy,
            },
          }),
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(updateTrips({ key: "loading", value: false }));
    }
  };

  // get the batteries
  useEffect(() => {
    getBatteries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // clear the timeout
  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(
        updateTrips({
          key: "toastMessage",
          value: { ...toastMessage, visible: false },
        }),
      );
    }, 5000);

    return () => clearTimeout(timeout);
  }, [dispatch, toastMessage]);

  // do not show anything when loading
  if (loading) {
    return <div />;
  }

  return (
    <div className="w-full">
      {batteriesInSystem.length === 0 ? (
        <BatteryEmptyState />
      ) : (
        <div className="w-full h-full">
          <div className="w-full mb-4 px-4 py-2 flex items-center justify-between rounded-lg bg-[#FDE8A8]">
            <p className="font-poppins text-xs font-medium">
              Recommended Number of Batteries
            </p>

            <div className="flex items-center gap-x-2">
              <div className="flex items-center gap-x-2">
                <BatterySecondaryIcon size={16} />
                <p className="font-aileron text-10 font-semibold">
                  {/* {required.batteries} Batteries */}
                  {required?.kawi370} Kawi 3.7.0 or {required?.kawi160} Kawi
                  1.6.0 Batteries
                </p>
              </div>

              <div className="w-[1px] h-4 bg-yellow" />

              <div className="flex items-center gap-x-2">
                <ChargerIcon size={16} />
                <p className="font-aileron text-10 font-semibold">
                  {required.energy} kWh
                </p>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-x-3">
            <CustomInput
              intent="searchHome"
              prefix={
                <img src="/assets/icons/search.svg" alt="" className="mr-2" />
              }
              value={search}
              focus={focus}
              border={search.length > 0 ? "success" : "none"}
              placeholderText="filterSelected"
              placeholder="Search Battery ID"
              onChange={(e) => setSearch(e.target.value)}
              suffix={
                search.length > 0 ? (
                  <CloseIcon
                    className="w-4 h-4 cursor-pointer stroke-dark-grey-text"
                    onClick={() => {
                      setSearch("");
                      setFocus(false);
                    }}
                  />
                ) : null
              }
            />
            <Button
              size="primary"
              width="generateUser"
              colors="grey"
              onClick={onClearSelection}
            >
              Clear Selection
            </Button>
          </div>

          <div className="h-[calc(100vh-374px)] mt-2 overflow-y-scroll">
            {filteredData.map((battery) => {
              const selected = tripDetails?.batteries?.includes(battery.id);

              return (
                <div
                  className={`flex justify-between h-10 px-6 border-b cursor-pointer hover:bg-primary-20 border-light-grey 
                  ${selected ? "bg-primary-20" : ""}`}
                  key={battery.id}
                  onClick={() => handleSelection(battery)}
                >
                  <div className="flex items-center gap-x-3">
                    <Checkbox checked={selected} />
                    <div className="flex items-center gap-x-2">
                      <p className="text-xs font-semibold text-black capitalize font-aileron">
                        {battery.value}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-x-6">
                    {battery.assignedTo ? (
                      <span className="text-[11px] font-medium text-yellow-dark bg-yellow-10 px-2 py-0.5 rounded  ">
                        Assigned to {battery.assignedTo || "--"}
                      </span>
                    ) : null}

                    <div className="w-[112px] flex justify-end">
                      {getBatteryStatus(battery.status)}
                    </div>

                    <span className="px-1.5 py-0.5 text-[10px] font-medium text-gray-600 bg-gray-100 rounded border border-gray-200">
                      {battery.lockerId || "--"}
                    </span>

                    <div className="w-[52px]">
                      <BatteryPercentageStatus
                        detail={battery}
                        showChargingStatus={false}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <ToastMessageModal
        visible={toastMessage.visible}
        onCancel={() =>
          dispatch(
            updateTrips({
              key: "toastMessage",
              value: { ...toastMessage, visible: false },
            }),
          )
        }
      />
    </div>
  );
};
export default TripStep5;
